import { Marker, Popup, NavigationControl } from 'react-map-gl'
import styled from 'styled-components'

const MapContainer = styled.div`
  padding: 15px 0;
  width: 100%;
  display: ${(props) => !props.show && 'none'};

  canvas {
    border-radius: 5px;
  }
`

const StyledMarker = styled(Marker)`
  z-index: ${(props) => (props.selected ? 3 : 0)};
`

const StyledPopup = styled(Popup)`
  z-index: 2;

  .mapboxgl-popup-content {
    padding: 0;
    width: 320px;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14),
      0px 1px 14px 0px rgba(0, 0, 0, 0.12);
  }
`

const AddJobPopup = styled(Popup)`
  z-index: 2;

  .mapboxgl-popup-content {
    padding: 0;
    width: 360px;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14),
      0px 1px 14px 0px rgba(0, 0, 0, 0.12);

    .mapboxgl-popup-close-button {
      z-index: 1;
    }
  }
`

const StyledNavigationControl = styled(NavigationControl)`
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 2;
`

export { StyledMarker, MapContainer, StyledPopup, AddJobPopup, StyledNavigationControl }
